<template>
    <div class="ui-data-item">
        <div class="ui-data-item__label">{{ label }}</div>
        <div class="ui-data-item__value">
            <slot />
        </div>
    </div>
</template>

<script setup lang="ts">
defineProps<{
    label: string;
}>();
</script>
